import { gateway } from "../../../../gateway";

export interface UpdateCompanyPayload {
  companyName: string;
  email: string;
  phone: string;
  address: string;
  state: string;
  zipCode: string;
  country: string;
  countryCode: string;
  dialCode: string;
}
export async function updateCompanyAction(data: UpdateCompanyPayload) {
  console.log("1. DATOS RECIBIDOS EN LA ACTION:", data);

  const payload = {
    businessName: data.companyName,
    email: data.email,
    businessPhone: data.phone,
    address: data.address,
    state: data.state,
    zipCode: data.zipCode,
    country: data.country,
    countryCode: data.countryCode,
    dialCode: data.dialCode,
  };

  console.log("2. PAYLOAD MAPEADO QUE SALE AL BACKEND:", payload);

  const response = await gateway.patch("/companies/self", payload);

  return response.data?.data ?? response.data;
}
